import { gunterzBold } from '@/theme/fonts';
import type { CategoryCardType } from '@/types';
import { AspectRatio, Box, Card, Flex, Image, NumberFormatter, type StyleProp, Text } from '@mantine/core';
export type CategoryCardProps = CategoryCardType & {
  isFlex?: boolean;
  w?: StyleProp<string | number>;
  p?: StyleProp<string | number>;
};
export const CategoryCard: React.FC<CategoryCardProps> = ({
  imgCard,
  title,
  priceColor,
  price,
  prefix,
  isFlex,
  w,
  p
}) => {
  return <Card bg="var(--striped-bg-color)" w={w} p={p} radius={5}>
      <Flex direction={{
      base: 'column',
      sm: !isFlex ? 'column' : 'row',
      md: 'column'
    }} align="center" gap={10}>
        <AspectRatio ratio={1 / 1}>
          <Image src={imgCard} alt="card" w={{
          base: 48,
          sm: 70
        }} h={{
          base: 48,
          sm: 70
        }} />
        </AspectRatio>
        <Box>
          <Text fz={{
          base: 14,
          sm: 18
        }} c={priceColor} className={gunterzBold.className}>
            <NumberFormatter value={price} thousandSeparator="," prefix={prefix} />
          </Text>
          <Text fz={{
          base: 10,
          sm: 12
        }} fw={700} mt={-6} c="var(--text-dark)" tt="uppercase" ta={{
          base: 'center',
          sm: !isFlex ? 'center' : 'left',
          md: 'center'
        }}>
            {title}
          </Text>
        </Box>
      </Flex>
    </Card>;
};